import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Div from "../../../widget/common/ui/Div";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { IconNormal } from "../../../widget/common/ui/Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import { DashboardContextImport } from "../../../provider/dashboard/DashboardContextProvider";
import { BadgeCircle } from "../../../widget/common/ui/Badge";
import { Position } from "../../../widget/common/ui/Stack";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { HomeContextImport } from "../../../provider/home/HomeContextProvider";
import { navigate } from "../../../service/navigation/Navigation";
import Center from "../../../widget/common/ui/Center";

const DashboardActions: React.FC<{ navIndex: number }> = ({ navIndex }) => {
  const type: number = ResponsiveDeviceType();
  let { dashboardNavBar } = DashboardContextImport();
  const { getBranchDetail, branchDetail, chatCount, noticeCount } =
    HomeContextImport();

  const chatCounter: string =
    SessionStorage.getValue(StorageKeys.home_chat_badge_counter) || "";
  const noticeCounter: string =
    SessionStorage.getValue(StorageKeys.home_notice_badge_counter) || "";

  const [chatBadgeCounter, setChatBadgeCounter] = useState<number>(
    UtilityHelper.isEmpty(chatCounter) ? 0 : Number(chatCounter)
  );
  const [noticeBadgeCounter, setNoticeBadgeCounter] = useState<number>(
    UtilityHelper.isEmpty(noticeCounter) ? 0 : Number(noticeCounter)
  );

  const initActions = () => {
    if (
      UtilityHelper.isEmpty(chatCounter) ||
      UtilityHelper.isEmpty(noticeCounter)
    ) {
      getBranchDetail();
    } else {
      setChatBadgeCounter(parseInt(chatCounter));
      setNoticeBadgeCounter(parseInt(noticeCounter));
    }
  };

  const badgeRender = (keyIndex: number) => {
    let badgeHtml = <></>;

    if ((type === 3 ? [1, 2] : [2, 3]).includes(keyIndex)) {
      badgeHtml = (
        <Position
          top={type === 3 ? 0 : -2}
          left={0}
          right={0}
          className={`h-100 w-100 px-2 d-flex justify-content-end`}
        >
          <BadgeCircle
            bgColor="red"
            counter={
              type === 3
                ? keyIndex === 1
                  ? chatBadgeCounter
                  : noticeBadgeCounter
                : keyIndex === 2
                ? chatBadgeCounter
                : noticeBadgeCounter
            }
          />
        </Position>
      );
    }
    return badgeHtml;
  };

  useEffect(() => {
    initActions();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (branchDetail != null) {
      setChatBadgeCounter(parseInt(chatCount!));
      setNoticeBadgeCounter(parseInt(noticeCount!));
    }
    // eslint-disable-next-line
  }, [branchDetail]);

  return (
    <Div className="bottom-nav-tab d-flex align-items-center justify-content-between">
      {dashboardNavBar &&
        dashboardNavBar.map((menu, key) =>
          type === 3 ? (
            <div
              key={key}
              role="button"
              onClick={() => navigate(menu.routeName)}
              className="position-relative"
            >
              <IconNormal name={menu.icon} color={AppTheme.themeFont} />
              {badgeRender(key)}
            </div>
          ) : (
            <div
              key={key}
              role="button"
              onClick={() => navigate(menu.routeName)}
              className="position-relative bottom-nav-item"
            >
              <Div className="text-center px-1">
                <Div style={{ height: `24px` }}>
                  <IconNormal
                    name={key === navIndex ? `${menu.icon}2` : menu.icon}
                    //color={AppTheme.themeFont}
                  />
                </Div>
                <Center>
                  <Div
                    className={`bottom-nav-name color-theme-font font-size-12_13 font-gotham-${
                      key === navIndex ? "bold current" : "book"
                    }`}
                  >
                    {AppTranslation.text(menu.name)}
                  </Div>
                </Center>
              </Div>
              {badgeRender(key)}
            </div>
          )
        )}
    </Div>
  );
};

export default DashboardActions;
